import BrandGroupBranchReportPage from "./BrandGroupBranchReportPage";

export default function GroupByBranchReportPage() {
  return <BrandGroupBranchReportPage dimension="group" />;
}
